import React, { useEffect } from "react";
import MyInput from "../../../components/formComponents/MyInput";
import MySelect from "../../../components/formComponents/MySelect";
import {
  Maintainance,
  Materials,
  sections,
  zones,
} from "../../../utils/options";
import { Button, Slider } from "@chakra-ui/react";
import MySlider from "../../../components/formComponents/MySlider";
import UploadFileStyleTwo from "../../project-showcase/admin/Presentation/Components/UploadFileStyleTwo";
import PrimaryButton from "../../../components/PrimaryButton";
import { materials } from "../../../utils/materialData";
import axios from "axios";
import { getAxiosConfig, getMinioImage } from "../../../utils/helpers";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import MyBoolean from "../../../components/formComponents/MyBoolean";

const initialFormData = {
  zones: [],
  sections: [],
  materialType: [],
  materialName: "",
  maintenance: "",
  minCost: 0,
  maxCost: 0,
  vendorAvailable: false,
  leadTime: 0,

  images: [],
};

const MaterialForm = ({ isEdit, materialId, onClose }) => {
  const [formdata, setFormData] = React.useState(initialFormData);
  const nav = useNavigate();

  async function handleSubmit(e) {
    // console.log("handleSubmit called" ,e);
    e.preventDefault();
    const FORMDATA = new FormData();
    console.log("JSON DATA", formdata);
    Object.entries(formdata).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        if (key === "images") {
          if (value.length === 1) {
            value = [value[0]];
          }
          value.forEach((item) => {
            if (typeof item === "object" && item instanceof File) {
              FORMDATA.append(`${key}[]`, item);
            } else {
              FORMDATA.append(`${key}[]`, item);
            }
          });
        } else {
          FORMDATA.append(key, value.join(","));
        }
      } else {
        FORMDATA.append(key, value);
      }
    });

    console.log(FORMDATA.get("images[]"), "FORMDATA in handleSubmit");
    // return ;
    try {
      if (isEdit) {
        await axios.put(
          `${process.env.REACT_APP_BACK_URL}/api/material/edit/${materialId}`,
          FORMDATA,
          getAxiosConfig({}, true),
        );
        toast.success("Material updated successfully");
        nav("/material/material-filter");
        onClose();
      } else {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACK_URL}/api/material/add`,
          FORMDATA,
          getAxiosConfig({}, true),
        );
        toast.success("Material added successfully");
        nav("/material/material-filter");
        // console.log(data, "data in handleSubmit");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
    console.log(formdata, "formdata in handleSubmit");
  }

  useEffect(() => {
    const fetchMaterial = async () => {
      try {
        const {
          data: { data },
        } = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/material/get/${materialId}`,
          getAxiosConfig(),
        );
        let temp = { ...data };
        console.log("PREV", temp);

        //  temp.images = temp?.images?.map((v)=> getMinioImage(v));
        console.log(temp);
        delete temp._id;
        delete temp.createdAt;
        delete temp.updatedAt;
        delete temp.__v;

        setFormData(temp);
      } catch (error) {
        console.error("Error fetching material:", error);
      }
    };
    if (materialId) {
      fetchMaterial();
    }
  }, [materialId]);
  // let   urlImages = formdata.images.map((v)=> typeof v=="string"? "https://design-api.airbrickinfra.com/api/minio/"+v : v)

  // console.log(formdata, "formdata in MaterialForm");
  return (
    <div className="p-4 bg-gray-100 rounded-xl ">
      <form onSubmit={handleSubmit} className=" gap-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <MySelect
              label={"Select Zones"}
              options={zones}
              multiple={true}
              required={true}
              onChange={(val) =>
                setFormData((prev) => ({ ...prev, zones: val }))
              }
              value={formdata.zones}
            />
          </div>
          <div>
            <MySelect
              label={"Select Sections"}
              options={sections}
              multiple={true}
              required={true}
              onChange={(val) =>
                setFormData((prev) => ({ ...prev, sections: val }))
              }
              value={formdata.sections}
            />
          </div>

          <div>
            <MySelect
              label={"Select Material"}
              options={Materials}
              multiple={true}
              required={true}
              onChange={(val) =>
                setFormData((prev) => ({ ...prev, materialType: val }))
              }
              value={formdata.materialType}
            />
          </div>
          <div>
            <MyInput
              label={"SKU Code"}
              placeholder={"Enter SKU Code"}
              required={true}
              value={formdata.materialName}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  materialName: e.target.value,
                }))
              }
            />
          </div>
          <div>
            <MyBoolean
              label={"Vendor Availability"}
              // options={["Available", "Not Available"]}
              // required={true}
              onChange={(val) =>
                setFormData((prev) => ({ ...prev, vendorAvailable: val }))
              }
              value={formdata.vendorAvailable}
              // required={true}
            />
          </div>
          <div>
            <MyInput
              label={"Lead Time"}
              placeholder={"Enter Lead Time"}
              type="number"
              // required={true}
              value={formdata.leadTime}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, leadTime: e.target.value }))
              }
            />
          </div>
          <div>
            <MySelect
              label={"Select Maintainance "}
              options={Maintainance}
              // required={true}
              onChange={(val) =>
                setFormData((prev) => ({ ...prev, maintenance: val }))
              }
              value={formdata.maintenance}
              // required={true}
            />
          </div>
          <div>
            <MySlider
              label={"Cost Range (in Rs.)"}
              // required={true}
              onChange={(val) =>
                setFormData((prev) => ({
                  ...prev,
                  minCost: val[0],
                  maxCost: val[1],
                }))
              }
              value={[formdata.minCost, formdata.maxCost]}
            />
          </div>
          <div>
            <UploadFileStyleTwo
              label={"Upload Images"}
              required={true}
              multiple={true}
              file={formdata.images}
              setFile={(file, isDelete) => {
                if (isDelete) {
                  setFormData((prev) => ({
                    ...prev,
                    images: file,
                  }));
                } else {
                  setFormData((prev) => ({
                    ...prev,
                    images: [...prev.images, ...file],
                  }));
                }
              }}
            />
          </div>
        </div>
        <div className="flex justify-end mt-4">
          <Button
            type="submit"
            colorScheme="teal"

            // className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            {isEdit ? "Update Material" : "Add Material"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default MaterialForm;
